import builder from '../builder';
import StyleTwoPinMarker from '../../streamline-icons/bold/style-two-pin-marker.svg';

export default builder('IconStyleTwoPinMarkerBold', StyleTwoPinMarker);
